"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleHandler = exports.LocaleRedirector = exports.LocaleProcessor = exports.init = exports.getLocaleRedirect = exports.getCurrentLanguage = exports.generateRedirectUrl = exports.getLocaleFromAcceptLang = exports.getLocaleFromCookie = exports.getPrioritizedLocale = exports.getLocalizedDestination = exports.getLocaleDataFromUrl = exports.getLocaleDataFromParams = exports.getMessagesForLocale = exports.transformConfigLocale = exports.transformLocale = exports.isLocaleSupported = exports.setLocaleCookie = exports.decodeLocale = exports.encodeLocale = exports.DEFAULT_LOCALE = void 0;
const route_1 = require("@epic-core/common/src/route");
const negotiator_1 = __importDefault(require("negotiator"));
let urlPattern;
let localePattern;
let destPattern;
exports.DEFAULT_LOCALE = 'en-US';
function encodeLocale(locale) {
    if (!locale)
        return null;
    return locale.replace(/-/g, '_');
}
exports.encodeLocale = encodeLocale;
function decodeLocale(locale) {
    if (!locale)
        return null;
    return locale.replace(/_/g, '-');
}
exports.decodeLocale = decodeLocale;
function setLocaleCookie(res, config, locale) {
    const path = config.localeCookiePath || (0, route_1.getPlainPath)();
    res.cookie(config.localeCookie || '', encodeLocale(locale), { path });
}
exports.setLocaleCookie = setLocaleCookie;
function isLocaleSupported(locale, config) {
    if (!config.allLocales || typeof config.allLocales.includes !== 'function' || !locale) {
        return false;
    }
    return config.allLocales.includes(locale);
}
exports.isLocaleSupported = isLocaleSupported;
function transformLocale(locale, config) {
    if (!locale || typeof locale !== 'string' || !locale.length)
        return null;
    const noSlashLocale = locale.replace(/\//g, '');
    const decodedLocale = decodeLocale(noSlashLocale) || 'en-US';
    if (config.overrideLocales && config.overrideLocales.hasOwnProperty(decodedLocale)) {
        return decodeLocale(config.overrideLocales[decodedLocale]);
    }
    return decodedLocale;
}
exports.transformLocale = transformLocale;
/**
 * Process the config so that it can be consumed by the locale handler
 * @param config
 * @returns {*}
 */
function transformConfigLocale(config) {
    config.supportedLocales = [];
    let allLocales = [];
    const localization = config.localization;
    if (localization) {
        for (const index in localization.supportedLocales) {
            if (!localization.supportedLocales.hasOwnProperty(index))
                continue;
            const locale = localization.supportedLocales[index];
            const encodedLocale = (locale && locale.hasOwnProperty('lang')
                ? locale.lang
                : locale);
            const decodedLocale = decodeLocale(encodedLocale) || 'en-US';
            allLocales.push(decodedLocale);
            config.supportedLocales.push({
                name: `epic.header.locale.name.${encodedLocale}`,
                lang: decodedLocale
            });
        }
    }
    if (!config.overrideLocales) {
        const localeRegex = /^grails\.plugins\.epiccontent\.localeOverrideMapping\.(.*)/;
        config.overrideLocales = {};
        for (const index in config) {
            if (!config.hasOwnProperty(index))
                continue;
            const matches = localeRegex.exec(index);
            if (matches) {
                const overrideLocale = matches[1];
                config.overrideLocales[overrideLocale] = config[index];
                const decodedLocale = decodeLocale(overrideLocale);
                if (decodedLocale) {
                    allLocales.push(decodedLocale);
                }
            }
        }
    }
    allLocales = allLocales.concat(Object.keys(config.overrideLocales));
    config.allLocales = allLocales;
    config.defaultLocale = exports.DEFAULT_LOCALE;
    return config;
}
exports.transformConfigLocale = transformConfigLocale;
function getMessagesForLocale(config, locale) {
    const transformedLocale = transformLocale(locale, config);
    const localization = config.localization;
    const messages = localization.messages;
    const messageProperties = messages[transformedLocale];
    return {
        messageProperties: messageProperties || null,
        supportedLocales: config.supportedLocales,
        defaultLocale: config.defaultLocale
    };
}
exports.getMessagesForLocale = getMessagesForLocale;
function getLocaleDataFromParams(req, config) {
    return transformLocale(req.query.lang, config);
}
exports.getLocaleDataFromParams = getLocaleDataFromParams;
function getLocaleDataFromUrl(req) {
    const url = req.originalUrl;
    const matches = localePattern.exec(url);
    if (matches && matches[1]) {
        return matches[1];
    }
    return null;
}
exports.getLocaleDataFromUrl = getLocaleDataFromUrl;
function getLocalizedDestination(url) {
    const matches = destPattern.exec(url);
    if (matches && matches.length > 2 && matches[2]) {
        return matches[2];
    }
    return '';
}
exports.getLocalizedDestination = getLocalizedDestination;
function getPrioritizedLocale(config, ...args) {
    for (const arg of args) {
        if (!!arg && isLocaleSupported(arg, config))
            return arg;
    }
    return exports.DEFAULT_LOCALE;
}
exports.getPrioritizedLocale = getPrioritizedLocale;
function getLocaleFromCookie(req, config) {
    return transformLocale(req.universalCookies.get(config.localeCookie), config); // requires universal-cookie-express
}
exports.getLocaleFromCookie = getLocaleFromCookie;
function getLocaleFromAcceptLang(req, config) {
    const negotiator = new negotiator_1.default(req);
    let locale;
    /**
     * if accept-language is not set, negotiator will assume the request accepts all languages
     * and negotiator.language() will pick the first lang in config.allLocales
     */
    if (req.get('accept-language')) {
        locale = negotiator.language(config.allLocales);
    }
    return transformLocale(locale, config);
}
exports.getLocaleFromAcceptLang = getLocaleFromAcceptLang;
function generateRedirectUrl(path, locale, url) {
    const transformedUrl = url.indexOf('/') !== 0 ? `/${url}` : url;
    return `${path}${locale}${transformedUrl}`;
}
exports.generateRedirectUrl = generateRedirectUrl;
function getCurrentLanguage(config, paramLocale, urlLocale, cookieLocale, acceptLocale) {
    const requestedLanguage = getPrioritizedLocale(config, paramLocale, cookieLocale, urlLocale, acceptLocale);
    return requestedLanguage;
}
exports.getCurrentLanguage = getCurrentLanguage;
function getLocaleRedirect(req, res, config, currentLanguage, baseUrlLocale, paramLocale, urlLocale, cookieLocale) {
    if (!urlLocale) {
        return generateRedirectUrl((0, route_1.getPath)(), currentLanguage, (0, route_1.processPathname)(req.originalUrl));
    }
    else if (paramLocale && paramLocale !== cookieLocale && isLocaleSupported(paramLocale, config)) {
        setLocaleCookie(res, config, paramLocale);
        return generateRedirectUrl((0, route_1.getPath)(), paramLocale, getLocalizedDestination(req.originalUrl));
    }
    else if (cookieLocale && cookieLocale !== urlLocale && isLocaleSupported(cookieLocale, config)) {
        return generateRedirectUrl((0, route_1.getPath)(), cookieLocale, getLocalizedDestination(req.originalUrl));
    }
    else if (baseUrlLocale !== urlLocale && isLocaleSupported(urlLocale, config)) {
        return generateRedirectUrl((0, route_1.getPath)(), urlLocale, getLocalizedDestination(req.originalUrl));
    }
    return generateRedirectUrl((0, route_1.getPath)(), currentLanguage, getLocalizedDestination(req.originalUrl));
}
exports.getLocaleRedirect = getLocaleRedirect;
function init(config) {
    urlPattern = new RegExp(`^${(0, route_1.getPath)()}([a-zA-Z0-9]{2}(?:[-_][a-zA-Z0-9]{2,4}){0,2})(/.*)?$`);
    localePattern = config.localePattern || urlPattern;
    destPattern = config.destPattern || urlPattern;
}
exports.init = init;
function LocaleProcessor(app, config) {
    init(config);
    app.use((req, res, next) => {
        // These locales may be transformed based on overrides or dealing with country code
        res.locals.paramLocale = getLocaleDataFromParams(req, config);
        res.locals.urlLocale = getLocaleDataFromUrl(req);
        res.locals.transformedUrlLocale = transformLocale(res.locals.urlLocale, config);
        res.locals.cookieLocale = getLocaleFromCookie(req, config);
        res.locals.acceptLocale = getLocaleFromAcceptLang(req, config);
        res.locals.countryCode = req.headers ? req.headers.geoip_country_code : 'US';
        res.locals.currentLanguage = getCurrentLanguage(config, res.locals.paramLocale, res.locals.transformedUrlLocale, res.locals.cookieLocale, res.locals.acceptLocale);
        next();
    });
}
exports.LocaleProcessor = LocaleProcessor;
function LocaleRedirector(app, config) {
    if (!urlPattern) {
        throw new Error('Cannot register LocaleRedirector without a LocaleProcessor');
    }
    app.use((req, res, next) => {
        // This is the locale as it appears in the url
        const { currentLanguage, urlLocale, paramLocale, transformedUrlLocale, cookieLocale } = res.locals;
        // If the url locale doesn't match the requested locale, we will get a redirect
        const redirectUrl = getLocaleRedirect(req, res, config, currentLanguage, urlLocale, paramLocale, transformedUrlLocale, cookieLocale);
        if (redirectUrl && redirectUrl !== req.originalUrl) {
            console.log('Locale Handler Redirecting URL: %s to %s', req.originalUrl, redirectUrl);
            res.redirect(redirectUrl);
        }
        else {
            next();
        }
    });
}
exports.LocaleRedirector = LocaleRedirector;
function LocaleHandler(app, config) {
    LocaleProcessor(app, config);
    LocaleRedirector(app, config);
}
exports.LocaleHandler = LocaleHandler;
//# sourceMappingURL=LocaleHandler.js.map